module.exports = __webpack_public_path__ + "static/img/56209c04f937f108bbb8d8fe35f888f.891c39b5.jpg";